import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ArcButton, ArcCheckbox, ArcDialog, ArcStack, ArcText } from "@src/core/ui";
import { selectShowTakeoffConfirm, setShowTakeoffConfirm } from '@src/features/drone/redux';
import { ConfirmTakeoffProps } from './types';
import { arcSpatium } from '@src/core/extensions';

const ConfirmTakeoff: React.FC <ConfirmTakeoffProps> = (props) => {
  const { takeOffAltitude } = props;
  const dispatch = useDispatch();
  const open = useSelector(selectShowTakeoffConfirm);
  const [isAgree, setIsAgree] = React.useState(false);

  const toggleAgree = () => {
    setIsAgree(!isAgree);
  };

  const handleClose = () => {
    setIsAgree(false);
    dispatch(setShowTakeoffConfirm(false));
  };

  const handleOk = () => {
    if (isAgree) {
      setIsAgree(false);
      dispatch(setShowTakeoffConfirm(false));
      window.dispatchEvent(new CustomEvent('takeoffConfirmed'));
    }
  };

  return (
    <ArcDialog open={open} onClose={handleClose} maxWidth='xs' fullWidth >
      <ArcStack spacing={2} marginTop={-3} sx={{ maxWidth: 400, paddingBottom: 1 }}>
        <ArcText.h5 sx={{marginTop: '-10px'}}>Takeoff altitude: {arcSpatium(Number(takeOffAltitude))}. Confirm Takeoff?</ArcText.h5>
        <ArcText.h6 color="text.secondary">Ensure the airspace is clear and all pre-flight checks are complete.</ArcText.h6>

        <ArcStack spacing={0.6} borderRadius={1} bgcolor='background.paper'>
          <ArcText.caption color='text.primary' fontSize={14}>
          1. Flight is authorized          
          </ArcText.caption>
          <ArcText.caption color='text.primary' fontSize={14}>
          2. Propellers are secure  
          </ArcText.caption>
          <ArcText.caption color='text.primary' fontSize={14}>
          3. Nothing is obstructing the drone’s path within 10 ft radius area 
          </ArcText.caption>
          <ArcText.caption color='text.primary' fontSize={14}>
          4. Stand at least 10 ft away from the drone    
          </ArcText.caption>
        </ArcStack>
        <ArcStack direction='row' alignItems='center'>
          <ArcCheckbox
            size='small'  
            color='brand' 
            title='Agree and confirm all items in checklist' 
            checked={isAgree} 
            onChange={() => toggleAgree()}
            sx={{ marginLeft: 0, padding: 0 }} />
          <ArcText.caption sx={{ marginLeft: 1 }}> Agree and confirm all items in checklist </ArcText.caption>
        </ArcStack>
        <ArcStack direction='row' spacing={1} justifyContent='flex-end'>
          <ArcButton.tertiary onClick={handleClose}> Cancel </ArcButton.tertiary>
          <ArcButton.brand disabled={!isAgree} onClick={handleOk}> Ok </ArcButton.brand>
        </ArcStack>
      </ArcStack>
    </ArcDialog>
  );
};

export default ConfirmTakeoff;